/**
 * Снимок видимой области страницы. Диалог баг-репорта и его оверлей временно скрываются,
 * чтобы не попасть в кадр (ПДн клиентов на экране остаются под контролем пользователя).
 */
export async function captureBugScreenshot(): Promise<Blob> {
  const dialog = document.querySelector<HTMLElement>('[data-testid="bug-report-dialog"]');
  const overlay = dialog?.previousElementSibling as HTMLElement | null;
  const prevDialog = dialog?.style.visibility ?? '';
  const prevOverlay = overlay?.style.visibility ?? '';
  if (dialog) dialog.style.visibility = 'hidden';
  if (overlay) overlay.style.visibility = 'hidden';
  try {
    await new Promise<void>((resolve) => {
      requestAnimationFrame(() => requestAnimationFrame(() => resolve()));
    });
    let toBlobFn: ((element: HTMLElement, options?: Record<string, unknown>) => Promise<Blob | null>) | null = null;
    try {
      const pkg = 'html-to-image';
      const mod = (await import(/* @vite-ignore */ pkg)) as {
        toBlob?: (element: HTMLElement, options?: Record<string, unknown>) => Promise<Blob | null>;
      };
      toBlobFn = mod.toBlob ?? null;
    } catch {
      toBlobFn = null;
    }
    if (!toBlobFn) {
      return new Blob([], { type: 'image/png' });
    }
    const blob = await toBlobFn(document.body, {
      backgroundColor: '#ffffff',
      cacheBust: true,
      pixelRatio: 1,
      width: window.innerWidth,
      height: window.innerHeight
    });
    if (!blob) throw new Error('Не удалось сделать снимок экрана');
    return blob;
  } finally {
    if (dialog) dialog.style.visibility = prevDialog;
    if (overlay) overlay.style.visibility = prevOverlay;
  }
}
